import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getContactRelationFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.contact_relations.description.label',
      contentValue: `{{ ${entity}contactRelation.description }}`,
      description: 'templates.contact_relations.description.description',
    },
    {
      label: 'templates.contact_relations.category_name.label',
      contentValue: `{{ ${entity}contactRelation.contactRelationCategory.name }}`,
      description: 'templates.contact_relations.category_name.description',
    },
    {
      label: 'templates.contact_relations.category_oposite_name.label',
      contentValue: `{{ ${entity}contactRelation.contactRelationCategory.opposite_name }}`,
      description: 'templates.contact_relations.category_oposite_name.description',
    },
  ];
};

export const templateContactRelation: EntityTemplateVariables = {
  fields: getContactRelationFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
